import { request } from './request'

/**
 * 获取年份列表
 * @returns {Promise<Array>} 年份列表 [2024, 2023, ...]
 */
export async function fetchYearList() {
  const res = await request.get('/api/emagazine/yearList')
  return res.data || []
}

/**
 * 获取杂志列表
 * @param {Number} year - 年份
 * @param {Number} pageSize - 每页数量
 * @param {Number} pageNum - 页码
 * @returns {Promise<Array>} 杂志列表
 */
export async function fetchMagazineList(year, pageSize = 1000, pageNum = 1) {
  const res = await request.post('/api/emagazine/list', {
    year,
    pageSize,
    pageNum
  })
  const data = res.data || {}
  const list = Array.isArray(data) ? data : (data.rows || data.list || data.records || [])
  return list
}

/**
 * 查看杂志详情
 * @param {String|Object} params - 可以是杂志编码字符串，也可以是包含 emagazineCode 和 codeToken 的对象
 * @returns {Promise<Object>} 杂志信息（含 pdfPath）
 */
export async function fetchMagazineView(params) {
  let dataParams
  
  // 如果传入的是字符串，直接作为 emagazineCode
  if (typeof params === 'string') {
    dataParams = { emagazineCode: params }
  } else if (typeof params === 'object' && params !== null) {
    // 如果是对象，直接使用
    dataParams = params
  } else {
    dataParams = { emagazineCode: params || '' }
  }
  
  const res = await request.post('/api/emagazine/view', dataParams)
  return res.data || {}
}

/**
 * 获取我的电子杂志列表
 */
export async function fetchMyMagazineList(pageNum = 1, pageSize = 12) {
  const res = await request.post('/api/emagazine/myList', { pageNum, pageSize })
  return res.data || {}
}
